import { DragSortTable } from "@ant-design/pro-components";

export default function CustomDragSortTable (props)  {

  return (
    <DragSortTable
      headerTitle={props.headerTitle}
      rowKey={props.rowKey}
      search={props.search}
      pagination={props.pagination}
      columns={props.columns}
      dataSource={props.dataSource}
      dragSortKey={props.dragSortKey}
      onDragSortEnd={props.handleDragSortEnd}
      {...props} 
    />
  );
}


// Hay otras paginas en las que se trabaja con columnas como el caso de reserve-details y tracking-details de ejemplo. Si bien no son drag and drop usan tablas y sirven de referencia porque tienen cosas similares.